export enum JobPositionTypeEnum {
  FullTime = 'FullTime',
  PartTime = 'PartTime',
  AsNeeded = 'AsNeeded'
}

export const JOB_POSITION_TYPE_DISPLAY: Record<JobPositionTypeEnum, string> = {
  [JobPositionTypeEnum.FullTime]: 'Full Time',
  [JobPositionTypeEnum.PartTime]: 'Part Time',
  [JobPositionTypeEnum.AsNeeded]: 'As Needed'
};
